<template>
    <div style="background: #f4f4f4;">
        <div class="containerTop">
            <div style="width: 1200px; margin: 0 auto">
                <div class="searchPart">
                    <div class="searchPartLeft">
                        <div
                            style="
                            font-size: 24px;
                            color: #000;
                            font-weight: 600;
                            height: 40px;
                            "
                        >
                        软件超市
                        </div>
                        <div class="classify">
                        <span>应用分类</span>
                    </div>
                    </div>
                    <div class="searchContainer">
                        <div class="flex searchContainerone">
                            <el-input
                                placeholder="在此输入你需要的服务"
                                v-model="searchInputValue"
                                class="input-with-select"
                                prefix-icon="el-icon-search"
                            >
                                <el-button slot="append" @click="handleCurrentChange(1)">
                                    搜索
                                </el-button>
                            </el-input>
                        </div>

                        <ul>
                            <li class="textLi" v-for="(dictionary, index) in hotSearch" :key="index"
                                @click="findHotSearch(dictionary.name)">{{dictionary.name}}
                            </li>
                        </ul>
                    </div>
                </div>
                
            </div>
        </div>


        <div class="container">
            <div class="flex" style="align-items: center;margin-bottom: 20px;">
                    <span style="font-size: 14px;padding-left: 5px;">当前位置：</span>
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item style="cursor: pointer;" :to="{name: 'apps'}">软件超市</el-breadcrumb-item>
                        <el-breadcrumb-item style="color: #009999">应用列表</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            <div class="screen">
                <div class="screenMess flex">
                    <div class="screenMessName">应用类型</div>
                    <div class="screenMessItem">
                        <p :class="severmessIndex2 == -1? 'screenMess_m1': 'screenMess_m'"
                           @click="getserveMess2(-1,'')">
                            全部
                        </p>
                        <p :class="severmessIndex2 == index? 'screenMess_m1': 'screenMess_m'"
                           v-for="(items, index) in typeList"
                           :key="index"
                           @click="getserveMess2(index,items.uuid)">
                            {{ items.typeName }}
                        </p>
                    </div>
                </div>
                <div class="screenMess flex" style="border-bottom: none;">
                    <div class="screenMessName">排&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;序</div>
                    <div class="screenMessItem">
                        <div
                            class="flex addMess"
                            v-for="(items, index) in addMessList"
                            :key="index"
                            @click="getAddMess(index)"
                            :class="addmessIndex == index ? 'p_active':''"
                        >
                            <p>{{ items.name }}</p>
                            <i v-if="addmessIndex == index && sortBoolean" class="el-icon-bottom"></i>
                            <i v-if="addmessIndex == index && !sortBoolean" class="el-icon-top"></i>
                            <!-- <div class="addMessIcon">
                              <i class="el-icon-arrow-up"></i>
                              <i class="el-icon-arrow-down"></i>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="recommendPosition">
                <div class="characteristic">推荐</div>
                <div class="recommendContent">
                    <div class="recommendComment" v-for="(item, index) in recommendTwoSoftware">
                        <div class="recommendCommentTop">
                            <el-image
                                :src="item.softwareLogo"
                                @click="getSassDetails(item.uuid)" style="cursor: pointer"
                                fit="fill" class="recommendLogo">
                            </el-image>
                            <div class="recommendInfo">
                                <div class="name" @click="getSassDetails(item.uuid)" style="cursor: pointer">
                                    {{item.softwareName}}
                                </div>
                                <!--<div class="price">¥{{item.money}}/次起</div>-->
                                <div class="price"  v-if="item.canBuy == 0">暂无价格</div>
                                <div v-else>
                                    <div class="price" v-if="item.price == null || item.price ==  undefined"><span>¥</span>未定价
                                    </div>
                                    <div class="price" v-if="item.price != null && item.price !=  undefined"><span>¥</span>{{number_format(item.price,
                                        2, ".", ",")}}/{{item.billingModeUnit}}起
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="recommendCommentBottom">
                            <div class="facilitatorNam">供应商：{{item.supplierName}}</div>
                            <div class="synopsis" @click="getSassDetails(item.uuid)" style="cursor: pointer;"
                                 :title="item.description">{{item.description}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section style="padding-bottom: 30px">
                <el-row :gutter="30">
                    <el-col :span="5">
                        <div class="leftCont">
                            <div class="rankingList">
                                <div class="rankingListTitle">热门排行榜</div>
                                <ul class="hotSell">
                                    <li v-for="(items, index) in hotList" :key="index">
                                        <div class="mpBox">
                                            <!--<div class="num">{{index + 1}}</div>-->
                                            <el-image @click="getSassDetails(items.uuid)"
                                                      style="width: 18px; height: 18px;cursor: pointer;"
                                                      :src="items.softwareLogo"
                                                      fit="fill"
                                            >
                                            </el-image>
                                            <div class="topServBoxInfo" style="margin-left: 15px;cursor: pointer;"
                                                 @click="getSassDetails(items.uuid)">
                                                <h3 :title="items.softwareName">{{ items.softwareName }}</h3>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="rankingList">
                                <div class="rankingListTitle">最新排行榜</div>
                                <ul class="hotSell">
                                    <li v-for="(items, index) in newList" :key="index">
                                        <div class="mpBox">
                                            <!--<div class="num">{{index + 1}}</div>-->
                                            <el-image
                                                @click="getSassDetails(items.uuid)"
                                                style="width: 18px; height: 18px;cursor: pointer;"
                                                :src="items.softwareLogo"
                                                fit="fill"
                                            >
                                            </el-image>
                                            <div class="topServBoxInfo" style="margin-left: 15px;cursor: pointer;"
                                                 @click="getSassDetails(items.uuid)">
                                                <h3 :title="items.softwareName">{{ items.softwareName }}</h3>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="19">

                        <section class="softwareList">
                            <ul v-if="searchList.length!=0">
                                <li
                                    v-for="(items, index) in searchList"
                                    :key="index" style="border-bottom: 1px solid #eee;">
                                    <div style="padding: 20px">
                                        <el-row :gutter="30" class="hotSellServ">
                                            <el-col :span="5">
                                                <div style="text-align: center">
                                                    <el-image
                                                        @click="getSassDetails(items.uuid)"
                                                        style="
                              width: 64px;
                              height: 64px;
                              margin: 0 5px 10px 0;
                              cursor: pointer;
                            "
                                                        :src="items.softwareLogo"
                                                        fit="fill"
                                                    >
                                                    </el-image>
                                                    <p style="text-align: center">
                                                        <el-rate
                                                            :value="items.score"
                                                            disabled
                                                            :colors="['#F7BA2A', '#F7BA2A', '#Da251d']"
                                                        >
                                                        </el-rate>
                                                    </p>
                                                </div>
                                            </el-col>
                                            <el-col :span="13">
                                                <div class="topServBoxInfo" @click="getSassDetails(items.uuid)"
                                                     style="cursor: pointer;">
                                                    <h3>{{ items.softwareName }}</h3>
                                                    <p style="margin-bottom: 15px">
                                                        {{ items.description }}
                                                    </p>
                                                    <!-- <p>交付时间：{{ items.date }}天</p> -->
                                                    <p>供应商：{{ items.supplierName }}</p>
                                                </div>
                                            </el-col>
                                            <el-col :span="6" style="text-align: right;font-size:14px" v-if="items.canBuy == 0">
                                                <p class="sPrice">暂无价格</p>
                                            </el-col>
                                            <el-col :span="6" style="text-align: right;font-size:14px" v-else>
                                                <p class="sPrice"
                                                   v-if="items.price == null || items.price ==  undefined">
                                                    <span>¥</span>未定价</p>
                                                <p class="sPrice"
                                                   v-if="items.price != null && items.price !=  undefined">
                                                    <span>¥</span>{{number_format(items.price, 2, ".",
                                                    ",")}}/{{items.billingModeUnit}}</p>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </li>
                            </ul>
                            <div v-else style="text-align:center;margin-bottom:20px;margin-top:20px" >
                                <img src="../../assets/nosearchMesg.jpg" alt="" style="width:200px">
                            </div>
                            <div style="text-align: center;padding: 10px 0;">
                                <el-pagination
                                    style="margin-right: -10px"
                                    background
                                    @current-change="handleCurrentChange"
                                    layout="prev, pager, next"
                                    :total="this.total">

                                    >
                                </el-pagination>
                            </div>
                        </section>
                    </el-col>
                </el-row>
            </section>
        </div>
    </div>
</template>

<script>
    import {getIndexDictionaryData, getSoftwareList, getSoftwareTypeList} from "../../utils/interface";

    export default {
        //   软件超市列表页
        name: "saasList",
        metaInfo: {
            title: '软件超市-水泵云', // set a title
            meta: [{                 // set meta
                name: 'keywords',
                content: 'saas平台 | 信息化软件 |人力资源软件 | SRM |crm |MES系统 | 生产管理软件 | 党建管理软件'
            },{                 // set meta
                name: 'description',
                content: '水泵云软件超市提供人力资源、行政、采购、营销、财务、党政等信息化产品软件服务，为水泵行业企业提供完整的信息化解决方案。'
            }],
        },
        components: {},
        data() {
            return {
                severmessIndex2: "-1",
                typeUuid:"",
                value: "",
                value2: "",
                value3: "",
                recommendTwoSoftware: [],
                softwaretopList: [],
                softwareList: [],
                input: "",
                hotSearch: [],
                softwareListbottom: [],
                addMessList: [
                    {
                        name: "发布时间",
                    },
                    {
                        name: "近180天成交数",
                    },
                    {
                        name: "评分",
                    },
                ],
                addmessIndex: "0",
                searchInputValue: '',
                tabParam: '',
                searchList: [],
                current: 1,
                pageSize: 10,
                hotList: [],
                newList: [],
                total: 0,
                typeList: [],
                sortBoolean: true,
            };
        },
        created() {
            this.tabParam = this.$route.query.tabParam;
            this.searchInputValue = this.$route.query.search;
            // this.searchInputValue = this.$route.query.searchValue;
            this.severmessIndex2 = this.$route.query.severmessIndex;
            this.typeUuid = this.$route.query.typeUuid;

            this.getSoftwareTypeList();
            this.getHotList();
            this.getNewList();

            if(this.typeUuid != '' && this.typeUuid != null){
                this.getserveMess2(this.severmessIndex2, this.typeUuid)
            }else{
                this.handleCurrentChange();
            }
            this.getBoutiqueSoftwareList();
            this.getHostSearch();


        },
        methods: {
            getSassDetails(uuid) {
                console.log(uuid)
                let routeData = this.$router.resolve({
                    name: "saasDetails",
                    params: {uuid: uuid},
                    query: {
                        titleName: "应用列表",
                        titleIndex: "list",
                        tabParam: this.tabParam,
                    }
                });
                window.open(routeData.href, "_blank");
            },
            findHotSearch(searchName) {
                this.searchInputValue = searchName;
                this.getSearchList()
            },

            getHostSearch() {
                console.log("getHostSearch")
                getIndexDictionaryData({
                    groupCode: "RJRS",
                }).then((response) => {
                    this.hotSearch = response;
                    console.log(response)
                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            getBoutiqueSoftwareList() {
                let param1 = {
                    current: 1,
                    pageSize: 2,
                    state: 1251,
                    isRecommend: true,
                    sort: "RECOMMEND_SORT",
                }
                getSoftwareList(param1).then((res) => {
                    this.recommendTwoSoftware = res.list;
                    console.log('22222',res.list );
                })
            },
            /*getSassDetails(uuid){
              console.log(uuid)
              let routeData = this.$router.resolve({
                name: "saasDetails",
                params: { uuid: uuid },
                query:{
                  titleName: "软件列表",
                  titleIndex: "list",
                  tabParam: this.tabParam,
                }
              });
              window.open(routeData.href, "_blank");
            },*/
            getserveMess2(i, uuid) {
                this.severmessIndex2 = i;
                this.typeUuid = uuid;
                this.searchInputValue = "";
                let param = {
                    softwareName: this.searchInputValue,
                    softwareType: this.typeUuid,
                    current: 1,
                    state: 1251,
                    pageSize: 10,
                }

                if (this.addmessIndex > -1) {
                    if (this.addmessIndex == 0) {
                        param.sort = "put_date";
                    } else if (this.addmessIndex == 1) {
                        param.sortsort = "orderNum";
                    } else if (this.addmessIndex == 2) {
                        param.sortsort = "score";
                    }
                    param.upDown = this.sortBoolean;
                }
                if(this.addmessIndex == 0) {
                    this.tabParam = ""
                }
                if (this.tabParam == "BOUTIQUE") {
                    //精品搜索
                    // param.isRecommend= true;
                    param.sort = "recommend_sort";
                } else if (this.tabParam == "NEW") {
                    //新品搜索
                    param.sort = "CREATE_DATE";
                }
                getSoftwareList(param).then((res) => {
                    this.searchList = res.list;
                    this.current = this.current + 1;
                    this.total = res.total;
                })
            },
            getAddMess(index) {
                if (index == this.addmessIndex) {
                    this.sortBoolean = !this.sortBoolean;
                } else {
                    this.sortBoolean = true;
                }
                this.addmessIndex = index;
                let sort = "";
                if (index == 0) {
                    sort = "put_date";
                } else if (index == 1) {
                    sort = "orderNum";
                } else if (index == 2) {
                    sort = "score";
                }
                this.getSearchList(sort, this.sortBoolean);

            },
            handleCurrentChange(page) {
                let param = {
                    softwareName: this.searchInputValue,
                    current: page,
                    state: 1251,
                    pageSize: this.pageSize,
                }
                if (this.tabParam == "BOUTIQUE") {
                    //精品搜索
                    param.isRecommend = true;
                } else if (this.tabParam == "NEW") {
                    //新品搜索
                    param.sort = "CREATE_DATE";
                }
                getSoftwareList(param).then((res) => {
                    this.searchList = res.list;
                    this.current = this.current + 1;
                    this.total = res.total;

                })
				window.scrollTo(0,0);
            },

            getSoftwareTypeList() {
                let param1 = {
                    current: 1,
                    pageSize: 20,
                }
                getSoftwareTypeList(param1).then((res) => {
                    this.typeList = res.list;
                })
            },

            //搜索列表
            getSearchList(sort, upDown) {
                let param = {
                    softwareName: this.searchInputValue,
                    current: this.current,
                    pageSize: this.pageSize,
                    state: 1251,
                }
                if (this.tabParam == "BOUTIQUE") {
                    //精品搜索
                    param.isRecommend = true;
                    param.sort = "RECOMMEND_SORT";
                    param.upDown = true;
                } else if (this.tabParam == "NEW") {
                    //新品搜索
                    param.sort = "CREATE_DATE";
                }
                if (sort != undefined && sort != "") {
                    //精品搜索
                    param.sort = sort;
                    param.upDown = upDown;
                }
                if (this.severmessIndex2 > -1) {
                    param.softwareType = this.typeUuid;
                }
                getSoftwareList(param).then((res) => {
                    this.searchList = res.list;
                    this.current = this.current + 1;
                    this.total = res.total;
                })
            },
            //热门列表
            getHotList() {
                let param = {
                    sort: 'page_views',
                    current: 1,
                    state: 1251,
                    pageSize: 10,
                }
                getSoftwareList(param).then((res) => {
                    this.hotList = res.list;
                })
            },
            //新品列表
            //热门列表
            getNewList() {
                let param = {
                    sort: 'create_date',
                    current: 1,
                    state: 1251,
                    pageSize: 10,
                }
                getSoftwareList(param).then((res) => {
                    this.newList = res.list;
                })
            },

            number_format(number, decimals, dec_point, thousands_sep) {
                /*
                * 参数说明：
                * number：要格式化的数字
                * decimals：保留几位小数
                * dec_point：小数点符号
                * thousands_sep：千分位符号
                * */
                number = (number + '').replace(/[^0-9+-Ee.]/g, '');
                var n = !isFinite(+number) ? 0 : +number,
                    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                    sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                    dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
                    s = '',
                    toFixedFix = function (n, prec) {
                        var k = Math.pow(10, prec);
                        return '' + Math.ceil(n * k) / k;
                    };

                s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
                var re = /(-?\d+)(\d{3})/;
                while (re.test(s[0])) {
                    s[0] = s[0].replace(re, "$1" + sep + "$2");
                }

                if ((s[1] || '').length < prec) {
                    s[1] = s[1] || '';
                    s[1] += new Array(prec - s[1].length + 1).join('0');
                }
                return s.join(dec);
            },
        },
    };
</script>

<style scoped lang="less">

    .containerTop {
        background: #fff;
        margin-bottom: 20px;

        .searchPart {
            width: 100%;
            padding: 18px 0 0;
            display: flex;

            .searchContainer {
                // width: 690px;
                margin: 0 auto;
                padding: 0 15px;

                .searchContainerone {
                    .input-with-select {
                        flex-shrink: 0;
                    }

                    .searchContainerButton {
                        color: #009999;
                        margin-left: 15px;
                        border: 1px solid #009999;
                        width: 88px;
                        background: #fff;
                        font-size: 14px;
                        border-radius: 10px;
                    }
                }

                /deep/ .input-with-select .el-input__inner {
                    border: 1px solid #009999;
                    border-top-left-radius: 20px;
                    border-bottom-left-radius: 20px;
                    background: #fdfdfd;
                    height: 40px;
                    line-height: 40px;
                }

                /deep/ .el-input-group {
                    height: 40px;
                    width: 618px;
                }

                /deep/ .input-with-select .el-input-group__append {
                    background: #009999;
                    color: #fff;
                    border: 1px solid #009999;
                    border-left: none;
                    border-radius: 0px 20px 20px 0px;
                    width: 80px;
                    box-sizing: border-box;
                    text-align: center;
                }

                ul {
                    display: flex;
                    color: #6E6E6E;
                    padding-left: 3px;

                    li {
                        font-size: 12px;
                        margin-top: 10px;
                        padding: 0 15px;

                        &.textLi {
                            // padding: 10px 20px 0 0;
                            cursor: pointer;
                            border-right: 1px solid #979797;

                            &:hover {
                                color: #009999;
                            }
                        }
                        &.textLi:last-child{
                            border: none !important;
                        }
                    }
                }
            }
        }

        .classify {
            font-size: 18px;
            width: 293px;
            color: #fff;
            background: #535353;
            height: 40px;
            line-height: 40px;
            padding: 0 10px;
            padding-left: 20px;
            box-sizing: border-box;
            margin-top: 10px;
            cursor: pointer;

            span {
                font-weight: 700;
            }
        }
    }

    .container {
        width: 1200px;
        margin: 0 auto;

        .searchPart {
            width: 100%;
            padding: 18px 0 5px;
            display: flex;

            .searchPartRight {
                width: 500px;
                padding: 0 15px;
                margin: 0 auto;

                /deep/ .el-input__inner {
                    border: 1px solid #009999;
                }

                /deep/ .el-input-group__append {
                    background-color: #009999;
                    color: #fff;
                    border: 1px solid #009999;
                }

                ul {
                    display: flex;
                    font-size: 12px;
                    color: #2c2f37;
                    padding: 3px 0;

                    li.topSearchTitle {
                        padding: 4px 6px;

                        &:hover {
                            cursor: pointer;
                            color: #009999;
                        }
                    }

                    li.line {
                        padding: 2px 0;
                        font-size: 14px;
                    }
                }
            }
        }

        .classify {
            width: 235px;
            color: #fff;
            background: #000;
            height: 35px;
            line-height: 35px;
            padding: 0 10px;
            box-sizing: border-box;
            cursor: pointer;

            span {
                font-weight: 700;
                font-size: 14px;
                padding-left: 5px;
            }
        }

        .screen {
            background-color: #fff;
            font-size: 14px;
            margin-bottom: 10px;
            border: 1px solid #dee2e6;

            .screenMess {
                border-bottom: 1px solid #dee2e6;
                align-items: center;

                .screenMessName {
                    width: 150px;
                    box-sizing: border-box;
                    padding: 10px;
                    text-align: center;
                    border-right: 1px solid #dee2e6;
                    color: #2c2f37;
                    font-size: 14px;
                    font-weight: bold;
                }

                .screenMessItem {
                    display: flex;
                    padding: 10px;
                    flex-wrap: wrap;
                }

                .screenMess_m {
                    cursor: pointer;
                    padding: 3px 15px;
                    font-size: 14px;
                }

                .screenMess_m1 {
                    cursor: pointer;
                    background: #009999;
                    border-radius: 5px;
                    color: #fff;
                    padding: 3px 15px;
                    font-size: 14px;
                }

                /deep/ .el-select {
                    margin-right: 20px;
                    width: 148px;
                }

                /deep/ .el-input__inner {
                    height: 30px;
                }

                /deep/ .el-input__icon {
                    line-height: 30px;
                }

                .addMess {
                    align-items: center;
                    cursor: pointer;
                    padding: 3px 15px;

                    p {
                        margin-right: 5px;
                    }

                    .addMessIcon {
                        flex-direction: column;
                        display: flex;

                        i {
                            // font-size: 10px;
                        }
                    }
                }

                .p_active {
                    cursor: pointer;
                    background: #009999;
                    border-radius: 5px;
                    color: #fff;
                    padding: 3px 15px;
                    font-size: 14px;
                }
            }
        }

        .recommendPosition {
            margin-bottom: 10px;
            background: #fff;
            border: 1px solid #009999;
            position: relative;
            padding: 25px;

            .characteristic {
                position: absolute;
                top: 0;
                right: 0;
                color: #fff;
                background: #009999;
                font-size: 14px;
                padding: 3px 5px;
            }

            .recommendContent {
                display: flex;

                .recommendComment {
                    width: 50%;
                    box-sizing: border-box;

                    .recommendCommentTop {
                        display: flex;
                        border-bottom: 1px solid #009999;
                        padding-bottom: 15px;

                        .recommendLogo {
                            width: 70px;
                            height: 70px;
                            padding-right: 20px;
                        }

                        .name {
                            margin: 5px 2px;
                            line-height: 1.6;
                            color: #2c2f37;
                            font-size: 14px;
                        }

                        .price {
                            margin: 5px 2px;
                            line-height: 1.6;
                            color: #f00;
                            font-size: 14px;
                        }
                    }

                    .recommendCommentBottom {
                        padding-top: 8px;

                        .facilitatorNam {
                            color: #505050;
                            font-size: 14px;
                            line-height: 1.6;
                        }

                        .synopsis {
                            color: #505050;
                            font-size: 14px;
                            line-height: 1.6;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }

                    &:nth-of-type(1) {
                        border-right: 1px solid #009999;
                        padding-right: 25px;
                    }

                    &:nth-of-type(2) {
                        padding-left: 25px;
                    }
                }
            }
        }

        .softwareList {
            background: #fff;
        }
    }

    .printBanner {
        background: url("../../assets/image/fulist.png");
    }

    .leftCont {
        .rankingList {
            background: #fff;
            margin-bottom: 25px;

            .rankingListTitle {
                padding: 12px;
                text-align: left;
                border-bottom: 1px solid #eee;
                color: #009999;
                font-size: 16px;
                font-weight: 600;
            }

            .hotSell {
                padding: 15px;

                li {
                    padding: 8px 0;
                    margin: 0;

                    .mpBox {
                        display: flex;
                        font-size: 14px;
                        color: #333;

                        .num {
                            padding-right: 5px;
                        }

                        img {
                            width: 18px;
                            height: 18px;
                        }

                        h3 {
                            margin: 0;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                            width: 150px;
                        }
                    }
                }
            }
        }

        .leftCard {
            margin-bottom: 30px;
            border: none;

            /deep/ .el-card__header {
                color: #009999;
                background-color: #f3f3f3;
                font-size: 18px;
                padding: 12px 20px;
            }

            /deep/ .el-card__body {
                background-color: #fbfbfb;
            }
        }

        .servInfo h3 {
            font-size: 16px;
            font-weight: normal;
            margin-bottom: 15px;
        }

        .servInfo .eval li {
            font-size: 14px;
            margin-bottom: 10px;
            display: flex;
        }

        .servInfo .eval li span {
            margin-right: 30px;
        }

        .servInfo .contact {
            margin-top: 30px;
            margin-bottom: -10px;
            font-size: 12px;
        }

        .servInfo .contact i {
            margin-right: 5px;
        }

        .servInfo .contact p {
            font-size: 14px;
            margin-bottom: 10px;
        }
    }

    .printTitle {
        font-size: 24px;
        font-weight: normal;
        color: #009999;
        margin-top: 30px;
        margin-bottom: 30px;
        border-bottom: 1px solid #e3e3e3;
        padding-bottom: 10px;

        span.tit {
            padding-bottom: 10px;
            border-bottom: 1px solid #009999;
        }

        span.more {
            font-size: 16px;
            float: right;
            margin-top: 10px;
        }

        .more i {
            color: #505050 !important;
        }
    }

    .bannerSearch {
        /deep/ .el-input__inner {
            height: 50px;
            line-height: 50px;
        }

        /deep/ .el-input-group__append {
            background-color: #009999;
            color: #fff !important;
            font-size: 18px;
            border-color: transparent;
        }
    }

    .hotSell {
        margin-bottom: -15px;

        li {
            margin-bottom: 15px;
        }

        .topServBoxInfo h3 {
            font-size: 14px;
            margin-bottom: 6px;
            font-weight: normal;
        }

        .topServBoxInfo p {
            font-size: 12px;
            color: #aaa;
        }

        /deep/ .el-rate__text {
            font-size: 12px;
        }
    }

    .hotSellServ {
        display: flex;
        align-items: center;

        p {
            /*text-align: center;*/
            font-size: 12px;
            color: #585858;
        }

        .topServBoxInfo h3 {
            font-size: 14px;
            margin-bottom: 6px;
            font-weight: normal;
        }
    }

    .relateServ {
        margin-bottom: -30px;

        li {
            margin-bottom: 15px;
        }

        .topServBoxInfo h3 {
            font-size: 14px;
            margin-bottom: 6px;
            font-weight: normal;
        }
    }

    .topServBox {
        background-color: #fff;
        height: 200px;
        border-radius: 8px;
        box-shadow: 0 1px 5px #eaeaea;
        margin-top: -100px;
        padding: 30px;
        box-sizing: border-box;

        .topServBoxInfo h3 {
            font-size: 16px;
            margin-bottom: 6px;
            font-weight: normal;
        }

        .topServBoxInfo p {
            font-size: 12px;
            color: #585858;
        }

        /deep/ .el-menu.el-menu--horizontal {
            border-color: transparent;
        }

        /deep/ .el-menu--horizontal > .el-menu-item.is-active {
            border: none !important;
            background-color: #f3f8ff;
            border-radius: 5px;
        }

        /deep/ .el-menu--horizontal > .el-menu-item {
            height: 30px;
            line-height: 26px;
        }
    }

    .topServBoxNum {
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: center;

        p:first-child {
            font-size: 16px;
        }

        p:last-child {
            font-size: 12px;
            color: #585858;
        }
    }

    .menu-sub {
        margin-top: 35px;
        font-size: 16px;
    }

    .box-card {
        margin-bottom: 30px;
        position: relative;

        .image {
            width: 100%;
            height: 200px;
            display: block;
        }
    }

    .compInfo p {
        text-indent: 2em;
        font-size: 14px;
        line-height: 1.8;
        color: #808080;
    }

    .mpBox {
        display: flex;
        align-items: center;
    }

    .mpCheck {
        position: absolute;
        right: 20px;
        top: 20px;
    }

    .mpTitle {
        font-size: 16px;
        font-weight: normal;
    }

    .mpComp {
        margin-top: 10px;
        font-size: 13px;
        color: #000000;
    }

    .mpPrice {
        margin: 10px 0;
        font-size: 13px;
        color: #da251d;

        span {
            color: #000;
            margin-left: 10px;
        }
    }

    .mpDetail {
        margin-top: 10px;

        dt {
            float: left;
            width: 70px;
            color: #000;
            font-size: 13px;
            font-weight: normal;
            line-height: 22px !important;
        }

        dd {
            font-size: 13px;
            line-height: 22px !important;
            margin-left: 70px;
            margin-bottom: 5px;
            color: #808080;
        }
    }

    .mpFooter-v1 {
        text-align: center;
        font-size: 14px;
        background: #f1f5fe;
        border: 1px solid #ebeef5;
        margin: -10px -21px -21px;
        height: 50px;
        line-height: 50px;
    }

    .mpFooter {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #fff;
        border-top: 1px solid #e3e3e3;
        margin: 0 0 -15px;
        position: relative;

        span {
            display: inline-block;
            width: 50%;
            text-align: center;
            font-size: 13px;
            height: 50px;
            line-height: 50px;
        }

        span a {
            font-size: 12px;
            color: #808080;
        }

        span a:hover {
            color: rgba(21, 126, 251, 0.8);
        }

        :after {
            position: absolute;
            content: "";
            width: 1px;
            background-color: #e3e3e3;
            height: 34px;
            top: 8px;
            left: 50%;
        }
    }

    .printBox {
        /deep/ .el-input--suffix .el-input__inner {
            padding: 0 15px;
        }
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both;
    }

    a {
        color: #009999;
    }

    a:hover {
        color: rgba(21, 126, 251, 0.8);
    }

    .mpTime {
        font-size: 12px;
        color: #aaa;
        margin-top: 6px;
    }
</style>



// WEBPACK FOOTER //
// src/components/saas/saasList.vue